export default class tools {
  static isJsonStr(jsonStr){
    if(this.isNull(jsonStr)){
      return false;
    }
    if(jsonStr.indexOf('{')==0 || jsonStr.indexOf('[')==0){
      return true;
    }
  }
  //去空函数
  static trim(str) {
    var localstr = new String(str);
    var pattern = /^\s+|\s+$/g;
    localstr = localstr.replace(pattern, "");
    return localstr;
  }
  //判断是否为空
  static isNull(s) {
    if (s == undefined || (this.trim(s) + "123" == "123")) {
      return true;
    }
    return false;
  }

  //获取location search参数
  static GetQueryString(locationSearch,name) { 
    var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)","i"); 
    var r = locationSearch.substr(1).match(reg); 
    if (r!=null) return (r[2]); return null; 
  }
}
